import * as actionTypes from "./actionTypes";
import axios from "axios";
import api from "../../shared/api";

export const getRoleStart=()=>{
    return { 
        type:actionTypes.GET_ROLE_START
    }
}

export const getRoleSuccess=(rolesList)=>{
    return {
        type:actionTypes.GET_ROLE_SUCCESS,
        roles:rolesList
    }
}

export const getRoleFail=(errorMessage)=>{
    return {
        type:actionTypes.GET_ROLE_FAIL,
        error:errorMessage
    }
}

export const getRoles=(token)=>{
    return async dispatch =>{
        dispatch(getRoleStart());
        let url =`${api}/roles`;
        const options = {
            url: url,
            method: 'GET',
            headers: {
                'Authorization': 'Bearer '+token
             },
            data:{}
          };
          await axios(options)
          .then(response => {
          dispatch(getRoleSuccess(response.data));
        })
        .catch(err => {
          dispatch(getRoleFail('get roles failed'));
        });
    }
}